import { styled } from 'styled-components';

import { spacing1 } from 'src/styles/spacing';

export const StyledDetailsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: ${spacing1} 0;

  &:last-child {
    margin-bottom: 0;
  }
`;
